import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import CustomDropDown from './customDropDown';
import { getCityAndState, getMRLDocument } from '../../Actions/educationActions';
function ABSelectEduLocation(props) {

  //Handling TP Dropdown
  const tpDropdown = useRef();
  const dispatch = useDispatch();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    //[name]: null,
  });


  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    console.log(formData);
  }

  const { type, 
    options, 
    attachOther, 
    verificationType, 
    name, 
    id, 
    placeholder, 
    fieldId, 
    isRequired, 
    errId, 
    caseCheckId, 
    returnType, 
    value, 
    hiddenValue, 
    selectedLabel, 
    checkDetailsIndex, 
    fieldName, 
    checkID, 
    isDisabled, 
    formName, 
    customError, 
    university_id } = props;


  ///////////////////////////////////////////////////////////

  const [selectedOptionId, setSelectedOptionId] = useState();
  const [showFilterDiv, setShowFilterDiv] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [runRequest, setRunRequest] = useState(false);
  const [autoSuggestOptionData, setAutoSuggestOption] = useState([]);
  const inputText = useRef();

  const inputTypeHandler = (e) => {
    var cols = document.getElementById(errId);
    cols.innerHTML = "";
    setKeyword(e.target.value);
    handleChange({
      name: e?.target?.value || "",
      value: e?.target?.value || ""
    })
    setSelectedOptionId(null);
    setRunRequest(true);

    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const [currentSelectedVal, setCurrentSelectedVal] = useState(null);

  const handleThirdPartyFloatingLabel = (e) => {
    //console.log('test'+currentSelectedVal);
    let parent = e.target.parentElement;
   // alert(keyword);
    while (!parent.classList.contains('floating-label'))
      parent = parent.parentElement;

    if (parent.children[1].classList.contains('focused')) {
      if (currentSelectedVal !== null || value || keyword !== '') {
        return false;
      } else {
        parent.children[1].classList.remove('focused');
        setCurrentSelectedVal(null);
      }
    } else {
      parent.children[1].classList.add('focused');
    }
  }  

  const apiresponse = (data) => {
    let formatOption = [];
    if(data?.data?.length){
      data?.data?.map(option => {
        formatOption.push({
          name: option,
          value: option
        })
      })
    }
    setAutoSuggestOption(formatOption);
    setShowFilterDiv(true);
  }

  useEffect(() => {

    const fetchData = async (value) => {
      const requestData = {
        param: value,
      };

      if (value.length >= 3) {
        dispatch(getCityAndState(requestData, apiresponse))
      }
      else {
        setShowFilterDiv(false);

      }
    };



    if (typeof keyword == "string" && keyword.length === 0) {
      console.log("string is empty");
      setShowFilterDiv(false);
      setAutoSuggestOption([]);
      //return false;
    } else {

      //  let storedToken = userData.token;
      if (selectedOptionId === null) {
  
        fetchData(keyword);
      } else {
        setShowFilterDiv(false);
      }
    }

  }, [runRequest, keyword]);


  const [reactSelect, setReactSelect] = useState();

  useEffect(() => {

    let stateValue = value;
    if (selectedLabel !== undefined) {
      stateValue = selectedLabel;
    }

    setReactSelect({ value: value, label: stateValue });
  }, []);

  useEffect(() => {
    let stateValue = value;
    if (selectedLabel !== undefined) {
      stateValue = selectedLabel;
    }
    setReactSelect({ value: value, label: stateValue });
  },[value, options])

  useEffect(() => {
    if(formName == 'DigiLocker'){
      if(!value){
        inputText.current.value = '';
      }else{
        inputText.current.value = value;
      }
    }
  },[value])




  useEffect(() => {

    let stateValue = value;
    if (selectedLabel !== undefined) {
      stateValue = selectedLabel;
    }

    setFormData(() => ({
      [name + "_value"]: hiddenValue,
    }));


  }, [hiddenValue]);

  const handleChange = (selectedOption) => {

    // alert(JSON.stringify(selectedOption));

    setCurrentSelectedVal(selectedOption.value);
    console.log(checkID);
    let record={};
    record.org_id=selectedOption.value;
    record.check_id=checkID;
    record.verification_type=1;
    // dispatch(getMRLDocument(record));
  
    setReactSelect(selectedOption);

    let value = selectedOption.value;
    if (returnType === 'name') {
      value = selectedOption.name;
    }

    // var value_element = document.getElementById(name+"_value");
    // value_element.value = selectedOption.value;
    setFormData((prevState) => ({
      [name + "_value"]: selectedOption.value,
    }));

    // alert(JSON.stringify(value))

    props.selectOption([{ "name": name, "value": value, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId, "caseCheckId": caseCheckId, "checkdetailsindex": checkDetailsIndex, "fieldname": fieldName,  optionValue : selectedOption?.value}]);
    setShowFilterDiv(false);
    //setKeyword(selectedOption.name);

    if (type === 3) {

      inputText.current.value = selectedOption.name;

    }

    //if this is an auto suggeest and other is selected then do something

    if (type === 3 && selectedOption.value === 'other') {

     // alert("other selected");

    }

    //if this is an auto suggeest and other is selected then do something

  };

  const hideOptions = () => {
    setShowFilterDiv(false);
  }

  let classNameD=props.pageName;
  let finalClassName="";
  if(classNameD=="Professional License"){
    finalClassName="col-sm-11 col-md-12 col-xl-11";
  }else if(classNameD=="add_que"){
    finalClassName="col-sm-12 col-md-12 col-xl-12";
  }

  
  else{
    finalClassName="col-sm-4 col-md-12 col-xl-4";
  }
  return (
    <>
    <div className="col-sm-4 col-md-12 col-xl-4">
  
      <div className="form-group">
        <div className="floating-label">
          {/* <label>Course Name</label> */}
          <input
            type="text"
            className="form-control"
            name={name}
            id={id}
            ref={inputText}
            onChange={inputTypeHandler}
            autoComplete="off"
            defaultValue={value}
            disabled={isDisabled}
          />
       
          <label htmlFor={props.id ? props.id : ''} className={(formData[name + "_value"] || keyword) && 'focused'}>{placeholder}{isRequired && <sup className="text-danger">*</sup>}</label>
        </div>
        {showFilterDiv && (
          <CustomDropDown
            optionData={autoSuggestOptionData}  
            selectOption={handleChange}
            hideOptions={hideOptions}
            classes="suggestion-list has-scroll"
          />
        )}
        { fieldName == 'university_board_other' || (fieldName == `verificationName_${caseCheckId}` && formName != 'DigiLocker') ?
          <>
           
            { customError?<p className="err_other text-danger">This field is required.</p> : <p className="err text-danger" id={fieldName == 'university_board_other' ? errId : id + "_hiddenvalue"} id1={id + "_value"}></p> }
             <input type="hidden" name={fieldName == 'university_board_other' ? name + "_value" : id + "_hiddenvalue"} id={id + "_value"} defaultValue={formData[name + "_value"]} />

           
          </>

          :
          <>
          <p className="err text-danger" id={errId}></p>

          <input type="hidden" name={name + "_value"} id={id + "_value"} defaultValue={formData[name + "_value"]} />
        </>
        }
      </div>
    </div>

  </>
  );
}

export default ABSelectEduLocation;
